




































import {Component, Emit, Vue} from 'vue-property-decorator'
import {namespace} from "vuex-class"

const roistat = namespace('roistat')
const profile = namespace("profile")

@Component({
  name: 'c-question-box-edit-dialog'
})
export default class QuestionBoxEditDialog extends Vue {
  @roistat.Action('sendEvent') protected sendEvent:any
  @profile.State("userCompany") protected userCompany: any
  editAnswerTitle: string = ''

  @Emit()
  close (): void {
    this.editAnswerTitle = ''
  }

  @Emit()
  save (): string {
    const value = this.editAnswerTitle

    this.editAnswerTitle = ''
    let params = [
      {
        "name": "“Анкета”: Действие “Добавить ответ”, сохранено",
        "data": {
          "company": this.userCompany.title
        }
      }
    ]
    this.sendEvent(params)
    return value
  }
}
